// extracted by mini-css-extract-plugin
export default {"a0":"KFl0KDXjTdDXf2Zgbm2T","cls1":"a8WYFwAAE9mHLAEWEJNA","cls2":"h1MLxf5Cn3ltA7muY1TA a8WYFwAAE9mHLAEWEJNA","isTabletUp":"HIBdvu1zNXxS25fp_l0M"};